export enum IReceiverTabs {
  addNewReceiver = "1",
  receiverTable = "2",
}

export interface ITableData {
  name: string;
  description: string;
}
